import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";
import WhatsappDashboardTable from './WhatsappDashboardTable';
import WhatsappForm from './WhatsappForm';
import SendMessageForm from './SendMessageForm';
import WebhookForm from './WebhookForm';
import PaymentForm from './PaymentForm';
import SalesforceConfigForm from './SalesforceConfigForm';
import GoogleDocsConfigForm from './GoogleDocsConfigForm';


const WhatsappDashboard = () => {
  const [phonenumberdata, setphonenumberdata] = useState([]);
  const [messagedata, setmessagedata] = useState([]);
  const [usermessagecredit, setusermessagecredit] = useState(0);
  const [showmodal, setshowmodal] = useState(false);
  const [formdata, setformdata] = useState({phonenumber:"", name:"", _id: null});

  const fetchdata = async () => {
    try {
      let data = await getdata({filter:{datatype:"phonenumberdata"}});
      setphonenumberdata(data.reverse());
      let mdata = await getdata({filter:{datatype:"sendmessagedata"}});
      setmessagedata(mdata.reverse());
      let usercreditdata = await fetch("/usermessagecredit" , {
          method: 'GET',
          headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${APPUSER.user.token}`}  
      });
      usercreditdata = await usercreditdata.json();
      setusermessagecredit(usercreditdata.usermessagecredit);
      console.log("fetchdata called");
    } catch (err) { console.error(err); }
  };


  const openedit = (item) => {
    setformdata({ name: item.name, phonenumber: item.phonenumber, _id: item._id});
    setshowmodal("showwhatsappform");
  };

  const opensend = (item) => {
    setformdata({ name: item.name, phonenumber: item.phonenumber, _id: item._id});
    setshowmodal("showsendmessageform");
  };

  const opensfconfig = (item) => {
    setformdata({_id:item._id});
    setshowmodal("showsfconfig");
  };

  const opengoogleconfig = (item) => {
    setformdata({_id:item._id});
    setshowmodal("showgoogleconfig");
  };

  const openwebhook = (item) => {
    setformdata({ name: item.name, phonenumber: item.phonenumber, _id: item._id, webhookmessage:item.webhookmessage});
    //setformdata(item);
    setshowmodal("showwebhookform");
  };

  const openpaymentform = () => {
    setformdata({});
    setshowmodal("showpaymentform");
  };

  const handlesubmit = async () => {
    let payload = {data:{...formdata, datatype:"phonenumberdata", datetime:formdata.date+"T"+formdata.time}};
    if (!payload._id) {
      payload.status = "linking pending";
    }
    console.log(payload);
    debugger;
    
    const result = await updatedata(payload, "/updatephonenumber");
    setshowmodal(false);
    fetchdata();
  };

  const deletephonenumber = (item) => {
    console.log("delete item", item);
    if(!confirm("Are you sure?")) return false;
    deletedata({filter:{datatype:"phonenumberdata", _id:item._id}}, () => {fetchdata(); });
  };

  useEffect(() => { fetchdata(); }, []);
  

  return (
    <div className="content-area">

      <button className="btn-blue" onClick={() => {
          let date = new Date();
          date.setDate(date.getDate()+1);
          date = formatdate(date);

          setformdata({ name:phonenumberdata[0]?.name, phonenumber:phonenumberdata[0]?.phonenumber, _id: null}); 
          setshowmodal("showwhatsappform");
          }}>
        + Add Phone Number
      </button>
       |
       message balance: {usermessagecredit}  | <a href="#" onClick={() => {openpaymentform();}}>Buy Messages</a>
      <WhatsappDashboardTable 
        userappointmentdata={phonenumberdata} 
        openedit={openedit} 
        deletephonenumber={deletephonenumber}  
        opensend={opensend}
        openwebhook={openwebhook} 
        opensfconfig={opensfconfig}
        opengoogleconfig={opengoogleconfig}
        />

      <WhatsappForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        formdata={formdata} 
        setformdata={setformdata}
        handlesubmit={handlesubmit}
        phonenumberdata={phonenumberdata}
      />

      <SendMessageForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        formdata={formdata} 
        setformdata={setformdata}
        handlesubmit={handlesubmit}
        phonenumberdata={phonenumberdata}
        messagedata={messagedata}
       
      />
      
      <WebhookForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        formdata={formdata} 
        setformdata={setformdata}
        phonenumberdata={phonenumberdata}
       
      />

      <PaymentForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        formdata={formdata} 
        setformdata={setformdata}
        phonenumberdata={phonenumberdata}
        paymentdata={[]}
       
      />
      <SalesforceConfigForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        phonenumber={formdata}
      />

      <GoogleDocsConfigForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        phonenumber={formdata}
      />
    </div>
  );
};

export default WhatsappDashboard;